import { format } from 'date-fns';
import { DATA_SECTION } from 'routes';
import { FEE_TYPE } from 'screens/booking/steps/FeeStep';

export enum FIELD_TO_VIEW {
	STRING,
	NUMBER,
	BOOLEAN,
	TIME,
	ENUM,
	PRICE,
	DATE,
	DISTANCE,
	EMAIL,
	LINK,
}

const PaymentValues = {
	PAYMENT_INVOICE: 'Faktura',
	PAYMENT_CASH: 'Hotovost',
};

const FeeValues = {
	FEE_FIXED: 'Fixni',
	FEE_OTHER: 'Jine podminky',
};

const AccomodationValues = {
	ACCOMODATION_HOTEL: 'Hotel',
	ACCOMODATION_PENSION: 'Pension',
	ACCOMODATION_PRIVATE: 'Privát',
};

export const fieldsToView = [
	{
		id: DATA_SECTION.EVENT,
		title: 'Akce',
		fields: [
			{ key: 'event_name', name: 'Název akce', type: FIELD_TO_VIEW.STRING },
			{ key: 'event_date', name: 'Datum', type: FIELD_TO_VIEW.DATE },
			{ key: 'event_address_place', name: 'Místo', type: FIELD_TO_VIEW.STRING },
			{ key: 'event_address_street', name: 'Ulice', type: FIELD_TO_VIEW.STRING },
			{ key: 'event_address_city', name: 'Město', type: FIELD_TO_VIEW.STRING },
			{ key: 'event_address_zip', name: 'PSČ', type: FIELD_TO_VIEW.STRING },
			{ key: 'event_address_gps', name: 'GPS Souřadnice', type: FIELD_TO_VIEW.LINK },
		],
	},

	{
		id: DATA_SECTION.PROMOTER,
		title: 'Promotér',
		fields: [
			{ key: 'promoter_name', name: 'Jméno', type: FIELD_TO_VIEW.STRING },
			{ key: 'promoter_email', name: 'E-mail', type: FIELD_TO_VIEW.EMAIL },
			{ key: 'promoter_phone', name: 'Telefonní číslo', type: FIELD_TO_VIEW.STRING },
		],
	},

	{
		id: DATA_SECTION.CONTRACT,
		title: 'Smlouva',
		fields: [
			{ key: 'contract_ico', name: 'IČO pro účely smlouvy', type: FIELD_TO_VIEW.STRING },
			{ key: 'contract_name', name: 'Název firmy', type: FIELD_TO_VIEW.STRING },
			{ key: 'contract_address_street', name: 'Ulice', type: FIELD_TO_VIEW.STRING },
			{ key: 'contract_address_city', name: 'Město', type: FIELD_TO_VIEW.STRING },
			{ key: 'contract_address_zip', name: 'PSČ', type: FIELD_TO_VIEW.STRING },
		],
	},

	{
		id: DATA_SECTION.SOUND,
		title: 'Zvukař',
		updateBadge: 'tech_update_at',
		fields: [
			{ key: 'tech_sound_name', name: 'Jméno', type: FIELD_TO_VIEW.STRING },
			{ key: 'tech_sound_email', name: 'E-mail', type: FIELD_TO_VIEW.EMAIL },
			{ key: 'tech_sound_phone', name: 'Telefon', type: FIELD_TO_VIEW.STRING },
		],
	},

	{
		id: DATA_SECTION.TECH_CONTACT,
		title: 'Kontaktní osoba v den akce',
		updateBadge: 'tech_update_at',
		fields: [
			{ key: 'tech_contact_name', name: 'Jméno', type: FIELD_TO_VIEW.STRING },
			{ key: 'tech_contact_email', name: 'E-mail', type: FIELD_TO_VIEW.EMAIL },
			{ key: 'tech_contact_phone', name: 'Telefon', type: FIELD_TO_VIEW.STRING },
		],
	},

	{
		id: DATA_SECTION.FEE,
		title: 'Honorář',
		fields: [
			{ key: 'fee_type', name: 'Typ', type: FIELD_TO_VIEW.ENUM, enumOptions: FeeValues },
			{
				key: 'fee_amount',
				name: 'Honorář',
				type: FIELD_TO_VIEW.PRICE,
				dependsOn: { property: 'fee_type', value: FEE_TYPE.FIXED },
			},
			{
				key: 'fee_travel',
				name: 'Cestovné',
				type: FIELD_TO_VIEW.PRICE,
				dependsOn: { property: 'fee_type', value: FEE_TYPE.FIXED },
			},
			{
				key: 'fee_total',
				name: 'Celkem',
				type: FIELD_TO_VIEW.PRICE,
				showVATCalculation: true,
				dependsOn: { property: 'fee_type', value: FEE_TYPE.FIXED },
			},
			{
				key: 'fee_other',
				name: 'Popis',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'fee_type', value: FEE_TYPE.OTHER },
			},
			{
				key: 'fee_payment_type',
				name: 'Způsob platby',
				type: FIELD_TO_VIEW.ENUM,
				enumOptions: PaymentValues,
			},
			{ key: 'fee_paying_name', name: 'Jméno', type: FIELD_TO_VIEW.STRING },
			{ key: 'fee_paying_email', name: 'E-mail', type: FIELD_TO_VIEW.EMAIL },
		],
	},

	{
		id: DATA_SECTION.TIMES,
		title: 'Časy',
		updateBadge: 'time_update_at',
		fields: [
			{ key: 'time_arrival', name: 'Příjezd', type: FIELD_TO_VIEW.TIME },
			{ key: 'time_podium_access', name: 'Přístup na podium', type: FIELD_TO_VIEW.TIME },
			{ key: 'time_sound_test', name: 'Zvuková zkouška', type: FIELD_TO_VIEW.TIME },
			{ key: 'time_dinner', name: 'Večeře', type: FIELD_TO_VIEW.TIME },
			{ key: 'time_hall_opening', name: 'Otevření sálu', type: FIELD_TO_VIEW.TIME },
			{ key: 'time_performance', name: 'Čas vystoupení', type: FIELD_TO_VIEW.TIME },
		],
	},

	{
		id: DATA_SECTION.ACOOMODATION,
		title: 'Ubytování',
		updateBadge: 'accomodation_update_at',
		fields: [
			{ key: 'accomodation', name: 'Ubytování', type: FIELD_TO_VIEW.BOOLEAN },
			{
				key: 'accomodation_type',
				name: 'Typ',
				type: FIELD_TO_VIEW.ENUM,
				enumOptions: AccomodationValues,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_name',
				name: 'Název ubytování',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_street',
				name: 'Ulice',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_city',
				name: 'Město',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_zip',
				name: 'PSČ',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_gps',
				name: 'GPS Souřadnice',
				type: FIELD_TO_VIEW.LINK,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_event_distance',
				name: 'Vzdálenost od klubu (km)',
				type: FIELD_TO_VIEW.DISTANCE,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_web',
				name: 'Web',
				type: FIELD_TO_VIEW.LINK,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_phone',
				name: 'Telefonní číslo',
				type: FIELD_TO_VIEW.STRING,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_check_in',
				name: 'Check-in',
				type: FIELD_TO_VIEW.TIME,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_check_out',
				name: 'Check-out',
				type: FIELD_TO_VIEW.TIME,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_breakfast',
				name: 'Snídaně',
				type: FIELD_TO_VIEW.BOOLEAN,
				dependsOn: { property: 'accomodation', value: true },
			},
			{
				key: 'accomodation_internet_access',
				name: 'Internet / Wi-fi',
				type: FIELD_TO_VIEW.BOOLEAN,
				dependsOn: { property: 'accomodation', value: true },
			},
		],
	},

	{
		id: DATA_SECTION.FILLED_BY,
		title: 'Vyplnil',
		dependsOn: { property: 'confirmed', value: true },
		fields: [
			{ key: 'confirmed_name', name: 'Jméno', type: FIELD_TO_VIEW.STRING },
			{ key: 'confirmed_email', name: 'E-mail', type: FIELD_TO_VIEW.EMAIL },
			{ key: 'confirmed_phone', name: 'Telefonní číslo', type: FIELD_TO_VIEW.STRING },
		],
	},
];

/**
 * Prices Utils
 */

export const formatPriceNumber = (price: number): string => {
	return Intl.NumberFormat('cs-CZ').format(price);
};

export const formatPrice = (price: number): string => {
	return formatPriceNumber(price) + ' CZK';
};

export const getPrices = (price) => {
	const withoutVAT = price ?? 0;
	const withVAT = (withoutVAT * 1.21).toFixed(2) ?? 0;
	const VAT = (parseFloat(withVAT) - withoutVAT).toFixed(2);

	return { withoutVAT, withVAT, VAT };
};

export const getFormattedPrice = (price, isVat) => {
	const { withoutVAT, withVAT } = getPrices(price);

	if (isVat) {
		return formatPrice(withVAT) + ' s DPH';
	}

	return formatPrice(withoutVAT);
};

/**
 * Transform time to HH:mm format
 *
 * @param value input in format e.g. HH:mm:ss
 * @returns HH:mm string
 */

export const transformTime = (value: string) => {
	if (!value) return value;

	return format(new Date('2020-01-01 ' + value), 'HH:mm');
};

export const getExternalUrl = (url: string) => {
	if (!url.startsWith('http')) {
		url = 'https://' + url;
	}

	return url;
};
